<template>
  <div style="margin: 0px; padding: 0px;">
    <div
      style="width: 200px; height: 200px; font-size:24px; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; margin: auto">
      {{ this.msg }}
      <br/>
      <br/>
      <br/>
      <el-button type="primary" @click="close()">关闭窗口</el-button>
    </div>
    <br/>
    <!-- <el-button type="primary" @click="close()">关闭窗口</el-button> -->
    <!-- <div v-html="sHtmlText"></div> -->
    <div style="width: 200px; height: 200px; font-size:24px;   margin: auto">
      <!-- <el-button type="primary" @click="close()">关闭窗口</el-button> -->
    </div>
  </div>
</template>
<script>
import {setCookie,getCookie} from '../../assets/js/cookie.js'
import axios from 'axios';

async function getAlipayAccessToken(appId, appSecret, code) {
  try {
    const response = await axios.post('https://openapi.alipay.com/gateway.do', {
      app_id: appId,
      method: 'alipay.open.auth.token.app',
      format: 'json',
      charset: 'utf-8',
      sign_type: 'RSA2',
      timestamp: new Date().toISOString(),
      version: '1.0',
      biz_content: JSON.stringify({ grant_type: 'authorization_code', code: '你的授权码' })
    }, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Alipay access token:', error);
    throw error;
  }
}

export default {
  data() {
    return {
      sHtmlText: '',
      msg:'支付宝登录页面跳转中。。。。。。'
    }
  },
  mounted() {
    this.getDate();
  },
  methods: {
    getDate() {
      // let that = this;
      // let data = {};
      // this.$ajax({
      //     method: 'post',
      //     url: this.GLOBAL.serverSrc + '/login/alipayauth.json',
      //     data: data,
      //     headers: {
      //         'Content-Type': 'application/json; charset=UTF-8'
      //     }
      // }).then(function(res) {
      //     if('0000000' == res.data.code){
      //         that.sHtmlText = res.data.sHtmlText;
      //         setTimeout(function() {
      //              document.forms['alipaysubmit'].submit();
      //         },100)
      //     }
      // })

      let auth_code = this.$route.query.auth_code == undefined ? '' : this.$route.query.auth_code;
      let state = this.$route.query.state == undefined ? 'alipaylogin' : this.$route.query.state;
      console.log('cauth_codeode:' + auth_code + ',state:' + state);
      let url = '';
      if (auth_code == '') {
        location.href = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021006119659013&scope=auth_user&redirect_uri=https://www.2office.cn/alipayauth&state=' + state;
      } else {
        console.log('auth_code11', auth_code);
        // let state = this.$route.query.state == undefined ? '' : this.$route.query.state;
        console.log('state',state);

        if(state == 'alipaylogin'){
          let that = this;
          let data = {  };
          this.$ajax({
            method: 'post',
            url:this.GLOBAL.serverSrc + '/alipay/login.json?code=' + auth_code,
            data: data,
            headers: {
              'Content-Type': 'application/json; charset=UTF-8'
            }
          }).then(function (res) {
            console.log(res);
            if('0000000' == res.data.code)
            {
                that.GLOBAL.token = res.data.token
                setCookie('2officesessionid',res.data.token,60*60*10)
                that.$router.push('/main')
            }
            else
            {
                alert(res.data.msg)
            }
          })

        }else if(state.indexOf('alipaybind')!=-1 ){
          let that = this;
          let token = state.substring(11);
          console.log('token', token);
          let data = {  };
          this.$ajax({
              method: 'post',
              url: this.GLOBAL.serverSrc + '/alipay/bindauth.json?code=' + auth_code,
              data: data,
              headers: {
                  'Content-Type': 'application/json; charset=UTF-8',
                  'token': token
              }
          }).then(function(res) {
              console.log(res);
              if('0000000' == res.data.code){
                that.msg = '支付宝绑定成功，请关闭当前页面，刷新用户基本信息页面';
              }else{
                  that.$message({
                      type: 'error',
                      message: res.data.msg
                  });
                  // that.$alert(res.data.msg)
                  return false;
              }
          })
        }

        
      }
    },

    close(){
      console.log('close');
        window.close();
    }
  },
  // watch:{
  //     sHtmlText:function(newVal, oldVal){
  //         //console.log("oldVal:" + oldVal);
  //         if(newVal && newVal !=''){
  //             console.log(newVal);
  //             document.forms['alipaysubmit'].submit();
  //         }


  //     }
  // }


}
</script>



// WEBPACK FOOTER //
// src/components/alipaylogin/alipayauth.vue